import type { Apollo } from 'src/gql/generated';

export function getCommunityCategoryDisplay(
  category: Pick<Apollo.CommunityCategory, 'emoji' | 'title' | '__typename'>
): string {
  const trimmedTitle = category.title.trim();
  const trimmedEmoji = category.emoji.trim();
  return `${trimmedEmoji} ${trimmedTitle}`;
}

export function createCommunityCategoryURLId(
  category: Pick<Apollo.CommunityCategory, 'title' | '__typename'>
): string {
  return category.title.trim().split(' ').join('-').toLowerCase();
}
